import type {Record} from 'typings/portaro.be.types';
import type {Component} from 'typings/portaro.fe.types';
import {recordTypes} from '../../commons/constants/portaro.constants';
import KpCover from '../kp-cover/KpCover.svelte';

interface KpSelectableRecordCardComponentBinding {
    record: Record,
    isSelected: boolean
}

/**
 * @ngdoc component
 * @name kpSelectableRecordCard
 * @module uc.record
 *
 * @param {Record} record
 * @param {boolean} isSelected
 *
 * @description
 *
 */
export class KpSelectableRecordCardComponent implements Component<KpSelectableRecordCardComponentBinding> {

    public static readonly componentName = 'kpSelectableRecordCard';

    public bindings = {
        record: '<',
        isSelected: '<'
    } as const;

    public templateUrl = require('./kp-selectable-record-card.tpl.ftl');
    public styleUrls = [require('./kp-selectable-record-card.less')]
    public controller = KpSelectableRecordCardComponentController;
}


class KpSelectableRecordCardComponentController implements KpSelectableRecordCardComponentBinding {
    record: Record;
    isSelected: boolean;
    public kpCoverComponent = KpCover;

    public canShowCover(): boolean {
        return !this.isExternal();
    }

    public isDocument(): boolean {
        return this.record.type === recordTypes.TYPE_DOCUMENT;
    }

    public isExternal(): boolean {
        return this.record.external;
    }
}